import React from 'react'
import { Button, ButtonGroup, Grid, Menu, MenuItem, withStyles, ListItemIcon, ListItemText } from '@material-ui/core'
import useRouter from 'utils/useRouter'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import HowToRegIcon from '@material-ui/icons//HowToReg'
import useStyles from './styles'

const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5',
  },
})((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
    {...props}
  />
))

const StyledMenuItem = withStyles((theme) => ({
  root: {
    '&:focus': {
      backgroundColor: theme.palette.secondary.main,
      '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
        color: theme.palette.common.white,
      },
    },
  },
}))(MenuItem)

export const MenuAcoes = (props) => {
  const classes = useStyles()
  const { vaga } = props //eslint-disable-line
  const router = useRouter()
  const [anchorEl, setAnchorEl] = React.useState(null)

  const handleClickBotaoAcoes = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleMenuBotaoAcoes = (to) => {
    router.history.push(to)
  }

  return (
    <Grid alignItems="flex-end" container spacing={1}>
      <Grid item>
        <ButtonGroup aria-controls="customized-menu" className={classes.actions} aria-haspopup="true" variant="contained" color="primary">
          <Button onClick={handleClickBotaoAcoes} endIcon={<ArrowDropDownIcon />}>
            Ações
          </Button>
        </ButtonGroup>
        <StyledMenu id="customized-menu" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>
          <StyledMenuItem onClick={() => handleMenuBotaoAcoes('/gerenciamentodevagas/cadastrodevagas')}>
            <ListItemIcon>
              <HowToRegIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Cadastrar vaga" />
          </StyledMenuItem>
        </StyledMenu>
      </Grid>
    </Grid>
  )
}
